import React, { Suspense, useEffect, useState, memo } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import MessageBox from "../../../UI/MessageBox/MessageBox";
import SidebarContextProvider, { useSidebarContext } from "./Sidebar/Context";
const Dashboard = React.lazy(() => import("../../dashboard/dashboard"));
const RoleList = React.lazy(() => import("../../role/RoleList"));
const UserList = React.lazy(() => import("../../users/List"));
const FacilityList = React.lazy(() => import("../../facility/CustomTabList"));
const PrincipleList = React.lazy(() => import("../../Principle/List"));

// const DockList = React.lazy(() => import('../../dock/List'));
const SupplierList = React.lazy(() => import("../../supplier/List"));
// const UomGroupList = React.lazy(() => import('../../uomgroup/List'));
const UomList = React.lazy(() => import("../../uom/CustomTabList"));
const LocationList = React.lazy(() => import("../../location/CustomTabList"));
const CustomerList = React.lazy(() => import("../../customer/List"));
const NotFound = React.lazy(() => import("../../NotFound/NotFound"));
const SkuList = React.lazy(() => import("../../SKU/CustomTabList"));
const AppointmentList = React.lazy(() => import("../../Appointment/List"));
const GateEntryList = React.lazy(() => import("../../GateEntry/List"));
const AgrnList = React.lazy(() => import("../../transaction/agrn/List"));
const GrnList = React.lazy(() => import("../../transaction/grn/CustomTabList"));
const InwardTypeList = React.lazy(() =>
  import("../../inwardtype/CustomTabList")
);
const HolidayCalendarList = React.lazy(() =>
  import("../../HolidayCalendar/Create")
);
const HolidaysList = React.lazy(() => import("../../Holidays/Create"));
const MobileUsersList = React.lazy(() => import("../../MobileUsers/List"));
const MobileRolesList = React.lazy(() => import("../../MobileRoles/RoleList"));
const ConsignorList = React.lazy(() => import("../../consignor/CustomTabList"));
const ConsignorV1List = React.lazy(() =>
  import("../../consignorv1/CustomTabList")
);
const CarrierList = React.lazy(() => import("../../carrier/CustomTabList"));
const CarrierListV1 = React.lazy(() => import("../../carrierV1/CustomTabList"));
const AppRegistration = React.lazy(() => import("../../AppRegistration/List"));
const CostAnalysisList = React.lazy(() =>
  import("../../Report/costanalysis/List")
);
const MarginAnalysisList = React.lazy(() =>
  import("../../Report/mariginanaysis/List")
);
const AppNotification = React.lazy(() => import("../../AppNotification/List"));
const InvRecoList = React.lazy(() => import("../../invReco/CustomTabList"));
const OrderTrackingAdmin = React.lazy(() => import("../../OrderTrackingAdmin"));

const BookShipmentList = React.lazy(() =>
  import("../../bookshipment/CustomTabList")
);
const OrderShipmentList = React.lazy(() =>
  import("../../ordershipment/CustomTabList")
);
const Dimensiongroup = React.lazy(() => import("../../dimensiongroup/Create"));
const Zoho = React.lazy(() => import("../../Report/Zoho/CustomTabList"));

export const LayoutContainer = (props) => {
  const loading = () => <div>Loading...</div>;
  const [isshowMessageBox, setIsShowMessageBox] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [messageBoxTitle, setMessageBoxTitle] = useState("Alert");
  const TabIndex = {
    BookShipmentList: 0,
    CarrierList: 0,
    Consignor: 0,
  };
  const location = useLocation();
  const path = location.pathname;

  const { isSidebarCollapsed } = useSidebarContext();

  useEffect(() => {
    const myObj = {
      carrier: "moduleStateCarrier",
      consignor: "moduleStateConsignor",
      bookshipment: "moduleState",
    };
    const pathValue = path.replace("/", "");
    if (pathValue in myObj) {
      let keysToRemove = [
        "moduleState",
        "moduleStateConsignor",
        "moduleStateCarrier",
      ];

      const index = keysToRemove.indexOf(myObj[pathValue]);
      if (index > -1) {
        keysToRemove.splice(index, 1);
      }

      keysToRemove.forEach((k) => localStorage.removeItem(k));
    }
  }, [path]);

  const handleCloseMessageBox = () => {
    setIsShowMessageBox(false);
  };

  const showMessageBoxSuccess = (title, message) => {
    setIsShowMessageBox(true);
    setIsErrorMessage(false);
    setMessageBoxTitle(title);
    setMessage(message);
  };

  const showMessageBoxFail = (title, message) => {
    setIsShowMessageBox(true);
    setIsErrorMessage(true);
    setMessageBoxTitle(title);
    setMessage(message);
  };
  return (
    <React.Fragment>
      {/* <!-- RIGHT DASHBOARD CONTENT START --> */}
      {path === "/role" ? (
        <div
          style={{
            paddingLeft: "8px",
            backgroundColor: "#F4F4F4",
            width: isSidebarCollapsed
              ? "calc(100% - 63px)"
              : "calc(100% - 229.4px)",
          }}
        >
          <div style={{ width: "100%" }}>
            <Suspense fallback={loading()}>
              <Switch>
                <Route
                  exact
                  path="/role"
                  name="role"
                  render={(props) => (
                    <RoleList
                      moduleCode="Mod_10"
                      label="Role"
                      routingLabel="User Management > Role"
                      {...props}
                      showMessageBoxSuccess={showMessageBoxSuccess}
                      showMessageBoxFail={showMessageBoxFail}
                    />
                  )}
                />
              </Switch>
            </Suspense>
          </div>
        </div>
      ) : (
        //  path == "/order-tracking" ? (
        //   <div>
        //     <Suspense fallback={loading()}>
        //       <Switch>
        //         <Route
        //           exact
        //           path="/order-tracking"
        //           name="Order Tracking Admin"
        //           render={(props) => <OrderTrackingAdmin {...props} />}
        //         />
        //       </Switch>
        //     </Suspense>
        //   </div>
        // ) :
        <div
          className={
            props.iscollapseLeftMenu === true
              ? "right-side-main-content main-content-right-side content-right-allignment move-content"
              : "right-side-main-content main-content-right-side content-right-allignment "
          }
          style={{ width: "78%" }}
        >
          <Suspense fallback={loading()}>
            <Switch>
              <Route
                exact
                path="/order-tracking"
                name="Order Tracking Admin"
                render={(props) => <OrderTrackingAdmin {...props} />}
              />
              <Route
                exact
                path="/"
                name="dashboard"
                //component={Dashboard}
                showMessageBoxSuccess={showMessageBoxSuccess}
                showMessageBoxFail={showMessageBoxFail}
                render={(props) => (
                  <Dashboard
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/costanalysis"
                name="Cost Analysis"
                render={(props) => (
                  <CostAnalysisList
                    moduleCode="Mod_58"
                    label="Cost Analysis"
                    routingLabel="Report > Cost Analysis"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/marginanalysis"
                name="Margin Analysis"
                render={(props) => (
                  <MarginAnalysisList
                    moduleCode="Mod_59"
                    label="Margin Analysis"
                    routingLabel="Report > Margin Analysis"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/role"
                name="role"
                render={(props) => (
                  <RoleList
                    moduleCode="Mod_10"
                    label="Role"
                    routingLabel="User Management > Role"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/users"
                name="role"
                render={(props) => (
                  <UserList
                    moduleCode="Mod_11"
                    label="User"
                    routingLabel="User Management > User"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/Principle"
                name="Principal"
                render={(props) => (
                  <PrincipleList
                    moduleCode="Mod_16"
                    label="Principal"
                    routingLabel="Masters > Principal"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/facility"
                name="Facility"
                render={(props) => (
                  <FacilityList
                    moduleCode="Mod_17"
                    label="Facility"
                    routingLabel="Masters > Facility"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/orders"
                name="Ecom-Orders"
                TabIndex={TabIndex}
                render={(props) => (
                  <OrderShipmentList
                    moduleCode="Mod_92"
                    label="Orders"
                    routingLabel="TMS > Orders"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/invreco"
                name="Carrier_Invoice_Reco"
                TabIndex={TabIndex}
                render={(props) => (
                  <InvRecoList
                    moduleCode="Mod_93"
                    label="Carrier Invoice Reco"
                    routingLabel="TMS > Carrier Invoice Reco"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/supplier"
                name="Supplier"
                render={(props) => (
                  <SupplierList
                    moduleCode="Mod_19"
                    label="Supplier"
                    routingLabel="Masters > Supplier"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/uom"
                name="UOM"
                render={(props) => (
                  <UomList
                    moduleCode="Mod_21"
                    label="UOM "
                    routingLabel="Masters > UOM "
                    {...props}
                  />
                )}
                showMessageBoxSuccess={showMessageBoxSuccess}
                showMessageBoxFail={showMessageBoxFail}
              />
              <Route
                exact
                path="/customer"
                name="Customer"
                render={(props) => (
                  <CustomerList
                    moduleCode="Mod_22"
                    label="Customer "
                    routingLabel="Masters > Customer "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/appregistration"
                name="AppRegistration"
                render={(props) => (
                  <AppRegistration
                    moduleCode="Mod_61"
                    label="App Registration "
                    routingLabel="Setting > App Registration "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/appnotication"
                name="AppNotification"
                render={(props) => (
                  <AppNotification
                    moduleCode="Mod_90"
                    label="App Notification "
                    routingLabel="Setting > App Notification "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/location"
                name="Location"
                render={(props) => (
                  <LocationList
                    moduleCode="Mod_23"
                    label="Location"
                    routingLabel="Masters > Location "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/SKU"
                name="sku"
                render={(props) => (
                  <SkuList
                    moduleCode="Mod_27"
                    label="Sku"
                    routingLabel="Masters > Sku "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/Appointment"
                name="Appointment"
                render={(props) => (
                  <AppointmentList
                    moduleCode="Mod_12"
                    label="Appointment"
                    routingLabel="Inward > Appointment"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/GateEntry"
                name="Gate Entry"
                render={(props) => (
                  <GateEntryList
                    moduleCode="Mod_13"
                    label="GateEntry"
                    routingLabel="Inward > GateEntry"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/agrn"
                name="AGRN"
                render={(props) => (
                  <AgrnList
                    moduleCode="Mod_14"
                    label="AGRN"
                    routingLabel="Inward > AGRN"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/grn"
                name="GRN"
                render={(props) => (
                  <GrnList
                    moduleCode="Mod_15"
                    label="GRN"
                    routingLabel="Inward > GRN"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/inwardtype"
                name="Inward Type"
                render={(props) => (
                  <InwardTypeList
                    moduleCode="Mod_33"
                    label="Inward Type"
                    routingLabel="Master> Inward Type"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/HolidayCalendar"
                name="HolidayCalendar"
                render={(props) => (
                  <HolidayCalendarList
                    moduleCode="Mod_34"
                    label="Holiday Calendar"
                    routingLabel="Masters > Holiday Calendar"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/MobileRole"
                name="Mobile Roles"
                render={(props) => (
                  <MobileRolesList
                    moduleCode="Mod_38"
                    label="Mobile Roles"
                    routingLabel="Masters > Mobile Roles"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/MobileUsers"
                name="Mobile Users"
                render={(props) => (
                  <MobileUsersList
                    moduleCode="Mod_39"
                    label="Mobile Users"
                    routingLabel="Masters > Mobile Users"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/consignor"
                name="Consignor"
                render={(props) => (
                  <ConsignorList
                    moduleCode="Mod_40"
                    TabIndex={TabIndex}
                    label="Consignor"
                    routingLabel="Masters > Consignor "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/carrier"
                name="Carrier"
                render={(props) => (
                  <CarrierListV1
                    moduleCode="Mod_43"
                    label="Carrier"
                    TabIndex={TabIndex}
                    routingLabel="Masters > Carrier "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/bookshipment"
                name="Book Shipment"
                TabIndex={TabIndex}
                render={(props) => (
                  <BookShipmentList
                    moduleCode="Mod_42"
                    label="Book Shipment"
                    routingLabel="TMS > Book Shipment"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route
                exact
                path="/dimensiongroup"
                name="Dimension Group"
                render={(props) => (
                  <Dimensiongroup
                    moduleCode="Mod_50"
                    label="Dimension Group"
                    routingLabel="TMS > Dimension Group"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />

              <Route
                exact
                path="/Invoices"
                name="Invoice"
                render={(props) => (
                  <Zoho
                    moduleCode="Mod_69"
                    label="Invoices"
                    routingLabel="Report >Invoices"
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />

              <Route
                exact
                path="/consignorv1"
                name="Consignor"
                render={(props) => (
                  <ConsignorV1List
                    moduleCode="Mod_96"
                    TabIndex={TabIndex}
                    label="Consignor"
                    routingLabel="Masters > Consignor "
                    {...props}
                    showMessageBoxSuccess={showMessageBoxSuccess}
                    showMessageBoxFail={showMessageBoxFail}
                  />
                )}
              />
              <Route component={NotFound} />
            </Switch>
          </Suspense>

          {isshowMessageBox && (
            <MessageBox
              isError={isErrorMessage}
              message={message}
              title={messageBoxTitle}
              onClose={handleCloseMessageBox}
            />
          )}
        </div>
      )}
      {/* <!-- DASHBOARD RIGHT END PART --> */}
      {/* <div className="dashboard-right-end">
              <div className="main-content-right-side-end">
                <strong>Help !</strong>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters,</p>
                <div className="unodered-list-text-rigth-side">
            <ul>
                <li>It is a long established fact that a reader will be distracted by the readable content of a page.</li>
                <li>It is a long established fact that a reader will be distracted by the readable content of a page.</li>
                <li>It is a long established fact that a reader will be distracted by the readable content of a page.</li>
            </ul>
                </div>
                <img src={helpIcon} alt="right-side help desk allignmnet"/>
              </div>
            </div> */}
    </React.Fragment>
  );
};

export default memo(LayoutContainer);
